import { LotteryConfigModel } from "../models/lottery-configuration-model";
import { Lottery } from "../../../models/lottery";

export const kamenyConfig: LotteryConfigModel = {
    lottery: Lottery.kameny,
    boardCount: 4,
    primaryBoardSize: 47,
    primaryNumbers: 31,
    primaryNumbersOffset: 5,
    boardLabel: "",

    defaultStake: 10,
    defaultStakeKasa: 2500,
    stakeOptions: Array.from({ length: 20 }, (_, i) => (i + 1) * 5),

    hasDurationComponent: false,
    hasDrawOptions: false,
    hasMultidrawNotification: false,
    hasAllOrOneMultidrawOptions: false,
    hasSubscription: false,
    hasCalculatedJackpot: true,

    isDrawnEveryDay: true,
    durationTitle: "Kameny losujeme <strong>každých 5 minut.</strong>",
    durationTitleShort: "Kameny losujeme každých 5 minut.",
    maxDuration: 34,
    durationOptions: [
        1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30,
        31, 32, 33, 34,
    ],
    multidrawDurationOptions: [],
};
